import { ApplicationIcon } from './ApplicationIcon';

/**
 * author: Michael Irigoyen
 * id DD3492E1-1F83-4E41-8BA9-9E6A1380D235
 * name application
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application.svg
 * tags
 */
export const IframeIcon = ApplicationIcon;
export default IframeIcon